import { ERRORS_MESSAGE } from "@lhd/constants";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { Checkbox, Form, FormInstance, Input, Select } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";

type PropsType = {
  form: FormInstance;
  appPart: AppPartType;
  getFieldClassName?: (name: string) => string;
};

const timeOptions = [
  "0:00",
  "0:30",
  "1:00",
  "1:30",
  "2:00",
  "2:30",
  "3:00",
  "3:30",
  "4:00",
  "4:30",
  "5:00",
  "5:30",
  "6:00",
  "6:30",
  "7:00",
  "7:30",
  "8:00",
  "8:30",
  "9:00",
  "9:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];

const TimeSetting: FC<PropsType> = ({ form, appPart, getFieldClassName }) => {
  const calc_type = appPart?.calc_type;
  const [defaultTime, setDefaultTime] = useState(calc_type === "time");

  useEffect(() => {
    if (defaultTime) {
      form.setFieldsValue({
        calc_type: "time",
        default_value: null,
      });
    } else {
      form.setFieldsValue({ calc_type: null });
    }
  }, [defaultTime, form]);

  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item valuePropName="checked" name="is_required_field">
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <label>初期値</label>
      <Form.Item name="calc_type" valuePropName="checked">
        <Checkbox
          onChange={(e) => setDefaultTime(e.target.checked)}
          checked={defaultTime}
        >
          デフォルトはレコードの作成時間.
        </Checkbox>
      </Form.Item>
      <Form.Item name="default_value">
        <Select
          disabled={!!defaultTime}
          options={timeOptions.map((o) => ({ label: o, value: o }))}
        />
      </Form.Item>
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default TimeSetting;
